export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_TWITCH_LOG = 'SET_TWITCH_LOG'

export const GET_USER_COMMANDS = 'GET_USER_COMMANDS'
export const SET_USER_COMMANDS = 'SET_USER_COMMANDS'
export const ADD_USER_COMMAND = 'ADD_USER_COMMAND'
export const DELETE_USER_COMMAND = 'DELETE_USER_COMMAND'


export const GET_SCHEDULED_MESSAGES = 'GET_SCHEDULED_MESSAGES'
export const SET_SCHEDULED_MESSAGES = 'SET_SCHEDULED_MESSAGES'
export const DELETE_SCHEDULED_MESSAGE = 'DELETE_SCHEDULED_MESSAGE'



